"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerForHostMessageNotification = exports.isWebView2BridgeInitialized = exports.initializeWebView2Bridge = void 0;
var PIEBridge = require("@microsoft/pie.sharedbridge");
// The PIE Bridge has two parts the shared and host specifc. The WebView2Bridge.WebView2BridgeImpl
// class provides the host specifc implementation for the a bridge using WebView2 to communicate
// to/from the host application. 
var WebView2BridgeImpl = /** @class */ (function () {
    function WebView2BridgeImpl(isBatchingEnabled, queueToHostFunc, queueFromHostFunc, messageSensor) {
        var _this = this;
        // When we recieve a message from the host we want to invoke the messageFromHostCallback
        // to avoid having to check if this is null or undefined we implement a noop callback
        this.messageFromHostCallback = function (envelope) { return void {}; };
        this.isBatchingEnabled = isBatchingEnabled;
        this.processBatchToHost = queueToHostFunc;
        this.processBatchFromHost = queueFromHostFunc;
        this.messageSensor = messageSensor;
        this.getWebview().addEventListener('message', function (event) {
            _this.messageFromHostCallback(event.data);
            if (_this.messageSensor) {
                _this.messageSensor(false, event.data);
            }
        });
    }
    // Called to send the JSON message to the host
    WebView2BridgeImpl.prototype.sendMessageToHost = function (envelope) {
        var webview = this.getWebview();
        if (webview) {
            webview.postMessage(envelope);
            if (this.messageSensor) {
                this.messageSensor(true, envelope);
            }
        }
    };
    // Called to invoke a PIE message synchronously
    WebView2BridgeImpl.prototype.invokeHostSync = function (webview, envelope) {
        var jsonData = '';
        try {
            jsonData = webview.hostObjects.sync.piehostbridge.invokeSync(JSON.stringify(envelope));
        }
        catch (exception) {
            // an exception is expected if the host object is not registered
            return { success: false, err: exception };
        }
        return {
            success: true,
            response: JSON.parse(jsonData)
        };
    };
    WebView2BridgeImpl.prototype.sendMessageToHostSync = function (envelope) {
        var webview = this.getWebview();
        if (webview) {
            var result = this.invokeHostSync(webview, envelope);
            if (result.success) {
                this.messageFromHostCallback(result.response);
                return;
            }
        }
        // if we reach this point the call failed
        throw PIEBridge.HostBridge.makePieSyncNotSupportedError();
    };
    // Returns the starting synchronous id that should be used by the bridge
    WebView2BridgeImpl.prototype.getStartingSyncId = function () {
        var webview = this.getWebview();
        if (webview) {
            try {
                return webview.hostObjects.sync.piehostbridge.getStartingSyncId();
            }
            catch (exception) {
                // an exception is expected if the sync host object is
                // not registered rather than throwing this exception fall
                // through and throw the PIE sync not supported exception
            }
        }
        // if we reach this point the call failed
        throw PIEBridge.HostBridge.makePieSyncNotSupportedError();
    };
    // Called to set the callback that will receive messages from the host.
    WebView2BridgeImpl.prototype.addHostMessageHandler = function (callback) {
        this.messageFromHostCallback = callback;
    };
    // Helper method to get the webView control, this allows for the code to be included
    // in jest tests that do not include the WebView
    WebView2BridgeImpl.prototype.getWebview = function () {
        // This is needed for cases when Window is not present.
        // Think of a file up the chain that imports this but doesnt use it.
        if (typeof (window) !== "object") {
            return null;
        }
        // ideally this would be window.chrome.webview, this syntax is not compatible with
        // the TypeScript DOM so we are using the ['chrome'] property and checking to make
        // sure it exists
        var chrome = window['chrome'];
        if (chrome) {
            return chrome.webview;
        }
    };
    return WebView2BridgeImpl;
}());
/**
* Ensures that the WebView2 bridge is initailzied, this method may be called multiple times
* parameters:
*   isBatchingEnabled - function that returns true when the batching mehtods should be called, if
*                       undefined batching will not be enabled
*   queueBatch - function that is called to process a batch from the host
*   queueMessage - function that is called to batch a message to the host
*   messageSensor - optionally provides a class that will be called with the messages sent to/from the host
*/
function initializeWebView2Bridge(isBatchingEnabled, queueBatch, queueMessage, messageSensor) {
    // Ensure there is a factory present and initialize the bridge
    if (!window.pieSharedBridgeFactory) {
        window.pieSharedBridgeFactory = PIEBridge.HostBridge.getSharedHostBridgeFactory(new WebView2BridgeImpl(isBatchingEnabled, queueBatch, queueMessage, messageSensor));
    }
    PIEBridge.HostBridge.initialize(window.pieSharedBridgeFactory);
}
exports.initializeWebView2Bridge = initializeWebView2Bridge;
// Returns true if the WebView2 bridge is initialized
function isWebView2BridgeInitialized() {
    var _a;
    return !!((_a = window) === null || _a === void 0 ? void 0 : _a.pieSharedBridgeFactory)
        && !PIEBridge.HostBridge.isInitializationNeeded(window.pieSharedBridgeFactory);
}
exports.isWebView2BridgeInitialized = isWebView2BridgeInitialized;
// Registers for notifications from the host message bridge
function registerForHostMessageNotification(callback) {
    return PIEBridge.HostBridge.registerForHostMessageNotification(callback);
}
exports.registerForHostMessageNotification = registerForHostMessageNotification;
//# sourceMappingURL=webview2Bridge.js.map